import {Model, ModelMixin} from '../../common/model.class';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class PracticeSpecialty extends ModelMixin() implements Model<PracticeSpecialty> {

    TYPE = PracticeSpecialty;

    public name: string;

    constructor(jsonData: any = {}) {
        super();
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/info/practicespecialty/practice-specialty.model.ts